import React from 'react';

export default (props) => {
    return (

        <svg width={props.width ? props.width : '224px'} height={props.height ? props.height : '86px'} viewBox="0 0 34 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsxlink="http://www.w3.org/1999/xlink">
            <title>Group</title>
            <desc>Created with Sketch.</desc>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Artboard" transform="translate(-465.000000, -153.000000)">
                    <g id="Group" transform="translate(466.000000, 154.000000)">
                        <path d="M24.8412299,-3.00935747e-14 C28.4391957,-3.00935747e-14 31.3559233,2.9167276 31.3559233,6.51469343 L31.3559233,20.8383461 C31.3559233,24.4363119 28.4391957,27.3530395 24.8412299,27.3530395 L22.6811837,27.3528114 L22.6815063,35.5489441 L17.5556677,27.3528114 L6.51469343,27.3530395 C2.9167276,27.3530395 0,24.4363119 0,20.8383461 L0,6.51469343 C0,2.9167276 2.9167276,-3.00935747e-14 6.51469343,-3.00935747e-14 L24.8412299,-3.00935747e-14 Z" id="Combined-Shape" stroke="#8B6BD9" stroke-width="1.68121121" fill="#8B6BD9" fill-rule="nonzero"></path>
                        <g id="$" transform="translate(9.123382, 1.368507)" fill="#FFFFFF" font-family="Roboto-Regular, Roboto" font-size="20.0967006" font-weight="normal">
                            <text>
                                <tspan x="0.288382763" y="19.5138456">$</tspan>
                            </text>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}